import React from 'react'

import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { INCLUDED_VALUE, SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import { updateSelectedFilters } from 'store/actions/filters'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import Dotdotdot from 'react-dotdotdot'
import CustomDropDownTreeSelect from 'components/ui/CustomDropdownTreeSelect'
import FilterTitle from 'components/ui/FilterTitle'

function MacroRegionalStrategiesMultiSelect({
  type,
  filterData,
  values,
  showFilter,
  customTop,
  keyWord,
  selection,
  title
}) {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters

  const selectedValues = filters.selectedFilters[currentSearchable][type][values[0]].map(
    option => ({
      label: option,
      id: option
    })
  )
  const options = filterData.map(option => {
    const parentOption = {
      label: option[keyWord],
      value: option.id,
      expanded: true
    }
    const selectedOption = selectedValues.filter(s => s.id === option.id)
    if (selectedOption.length > 0) {
      parentOption.checked = true
    } else if (option.id === INCLUDED_VALUE && selectedValues.length === 0) {
      parentOption.checked = true
    }
    return parentOption
  })

  const onChange = (currentNode, selectedNodes) => {
    let filterValue = selectedNodes.map(node => node.value)
    if (currentNode.value === INCLUDED_VALUE) {
      filterValue = []
    } else {
      filterValue = filterValue.filter(value => value !== INCLUDED_VALUE)
    }
    const data = {
      filterType: type,
      filterId: values[0],
      filterValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function handleFilterRemove(filterId, filterValue, valueIsArray = false) {
    let resultingValue = null
    if (valueIsArray) {
      resultingValue = filters.selectedFilters[currentSearchable][type][filterId].filter(
        s => s.id !== filterValue.id || s !== filterValue
      )
    }
    const data = {
      filterType: type,
      filterId,
      filterValue: resultingValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function renderSelectedValues() {
    return values.map(value => {
      if (filters.selectedFilters[currentSearchable][type][value]) {
        const filterValue = filters.selectedFilters[currentSearchable][type][value]
        if (filterValue instanceof Array) {
          return filterValue.map(v => (
            <SelectedFilterContainer className="selected-filters" key={v}>
              <SelectedFilter>
                <FilterText title={v}>
                  <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{v.toUpperCase()}</Dotdotdot>
                </FilterText>
                <RemoveIcon
                  className="far fa-times"
                  onClick={() => handleFilterRemove(value, v, true)}
                />
              </SelectedFilter>
            </SelectedFilterContainer>
          ))
        }
      }
      return false
    })
  }

  return (
    <>
      {!selection ? (
        <SearchFilter open={showFilter} customTop={customTop}>
          <div className="sticky-container">
            {title ? <FilterTitle>{title}</FilterTitle> : null}
            <CustomDropDownTreeSelect data={options} onChange={onChange} />
          </div>
        </SearchFilter>
      ) : (
        <div className="selected-fl">{renderSelectedValues()}</div>
      )}
    </>
  )
}

MacroRegionalStrategiesMultiSelect.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.array,
  values: PropTypes.array,
  title: PropTypes.string,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string,
  keyWord: PropTypes.string,
  selection: PropTypes.bool
}

export default MacroRegionalStrategiesMultiSelect
